import {useAtom} from 'jotai'

import {
  listAtom,
  listFilterAtom,
  listFilterTrxAtom,
  listFilterPackageAtom,
  listFilterMarketingAtom,
  memberDetailAtom,
  memberDetailTabAtom,
  tabNameAtom,
  listFilterActivitiesAtom,
  activityListAtom,
  purchaseListAtom,
  purchaseListFilterAtom,
} from '../store'

export const useMember = () => {
  const [list, listSet] = useAtom(listAtom)
  const [listActivities, listActivitiesSet] = useAtom(activityListAtom)
  const [listFilter, listFilterSet] = useAtom(listFilterAtom)
  const [listFilterTrx, listFilterSetTrx] = useAtom(listFilterTrxAtom)
  const [listFilterPackage, listFilterPackageSet] = useAtom(listFilterPackageAtom)
  const [listFilterActivities, listFilterActivitiesSet] = useAtom(listFilterActivitiesAtom)
  const [listFilterMarketing, listFilterSetMarketing] = useAtom(listFilterMarketingAtom)

  const [listPurchase, listPurchaseSet] = useAtom(purchaseListAtom)
  const [listPurchaseFilter, listPurchaseFilterSet] = useAtom(purchaseListFilterAtom)

  const [tabName, tabNameSet] = useAtom(tabNameAtom)

  const [detail, detailSet] = useAtom(memberDetailAtom)
  const [detailTab, detailTabSet] = useAtom(memberDetailTabAtom)

  const updateDetail = (
    data: any,
    type:
      | 'Segment'
      | 'Address'
      | 'Consent'
      | 'Transaction'
      | 'Packages'
      | 'Activities'
      | 'Engagement'
      | 'SmsEngagement'
      | 'PushEngagement'
      | 'EmailEngagement'
  ) => {
    detailTabSet((prev) => {
      // if (!prev) return null

      return {
        ...prev,
        [type]: data,
      }
    })
  }

  return {
    list,
    listSet,
    listActivities,
    listActivitiesSet,
    detail,
    detailSet,
    tabName,
    tabNameSet,
    detailTab,
    detailTabSet,
    updateDetail,
    listFilter,
    listFilterSet,
    listFilterActivities,
    listFilterActivitiesSet,
    listFilterTrx,
    listFilterSetTrx,
    listFilterPackage,
    listFilterPackageSet,
    listFilterMarketing,
    listFilterSetMarketing,
    listPurchase,
    listPurchaseSet,
    listPurchaseFilter,
    listPurchaseFilterSet,
  }
}
